import { OmrState } from './state';

export const mutations = {
    setImgList(state: OmrState, payload: string[]) {
        state.uploadImageState.img_list = payload;
    },
    setScoreName(state: OmrState, payload: string) {
        state.uploadImageState.score_name = payload;
    },
    setAutoShowStatementDialog(state: OmrState, payload: boolean) {
        state.autoShowStatementDialog = payload;
    },
};
